import React, {useState} from 'react';
import Typography from "@material-ui/core/Typography";
import {Button, Grid, TextField} from "@material-ui/core";
import WhiteHeaderCard from "../../../../../components/ui/cards/white-header-card/WhiteHeaderCard";
import {makeStyles} from "@material-ui/core/styles";
import {colors} from "../../../../colors";
import PropTypes from "prop-types";
import * as actions from "../../../../../store";
import {useDispatch, useSelector} from "react-redux";
import {emailRegex, getImeiListFromDevices} from "../../../../utils/utils";
import RichiestaInviataDialog from "../../richiesta-inviata-dialog/RichiestaInviataDialog";

const useStyles = makeStyles({
    cardContent: {
        color: colors.font.light,
    },
    inputFieldStyle: {
        width: "95%",
    },
    gridCenteredInputs: {
        alignSelf: "center",
    }
});

const GuastoTerminaleDialog = (props) => {
    const classes = useStyles();

    const [tipoGuasto, setTipoGuasto] = useState("");
    const [ritiroTerminale, setRitiroTerminale] = useState("");
    const [mailDiContatto, setMailDiContatto] = useState("");
    const [numeroTelefonicoDiContatto, setNumeroTelefonicoDiContatto] = useState("");
    const [firstTimeEmail, setFirstTimeEmail] = useState(0);
    const [firstTimeTelephone, setFirstTimeTelephone] = useState(0);
    const [openRichiestaInviata, setOpenRichiestaInviata] = useState(false);

    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId);
    const userId = useSelector(state => state.authReducer.userClaims.uid);
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error);
    const dispatch = useDispatch();

    const disableButton = () => {
        return tipoGuasto.length === 0 ||
            ritiroTerminale.length === 0 ||
            numeroTelefonicoDiContatto.length === 0 ||
            !emailRegex.test(String(mailDiContatto.toLowerCase()));
    }

    const handleRichiestaInviataButton = () => {
        setOpenRichiestaInviata(false);
        props.closeAssistenza();
    }

    const handleTipoGuastoChange = (event) => {
        setTipoGuasto(event.target.value);
    }

    const handleRitiroTerminaleChange = (event) => {
        setRitiroTerminale(event.target.value);
    }

    const handleMailDiContattoChange = (event) => {
        setMailDiContatto(event.target.value);
        setFirstTimeEmail(1);
    }

    const handleNumeroTelefonicoDiContattoChange = (event) => {
        setNumeroTelefonicoDiContatto(event.target.value);
        setFirstTimeTelephone(1);
    }

    const handleConttataciClick = () => {
        const imeiList = getImeiListFromDevices(props.selectedDevices);
        dispatch(actions.sendVpServiceRequest(imeiList, tipoGuasto, ritiroTerminale, mailDiContatto, numeroTelefonicoDiContatto,
            integrationId, userId));
        setOpenRichiestaInviata(true);
    }

    return (
        <React.Fragment>
            <WhiteHeaderCard title={"Guasto terminale"}>
                <div>
                    <Typography variant="body2" className={classes.cardContent}>
                        Se hai bisogno di riparare o sostituire un terminale non esitare a contattarci
                    </Typography>
                    <Typography variant="body2" className={classes.cardContent + " mb-8"}>
                        Bastano poche informazioni per procedere con la richiesta:
                    </Typography>
                </div>
                <Grid container>
                    <Grid item xs={12} md={3} className="mt-24">
                        <Typography variant="subtitle2">
                            Tipo Guasto
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={9} className={classes.gridCenteredInputs}>
                        <TextField
                            className={classes.inputFieldStyle}
                            onChange={(event) => handleTipoGuastoChange(event)}
                            placeholder={"Inserisci il tipo di guasto"}
                            value={tipoGuasto}
                            required
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item container xs={12} md={3} className="mt-24">
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">
                                Indirizzo completo di ritiro terminale
                            </Typography>
                        </Grid>
                        <Grid>
                            <Typography variant={"body2"} className={classes.cardContent}>
                                (Referente, Via, Città e CAP)
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={9} className={classes.gridCenteredInputs}>
                        <TextField
                            className={classes.inputFieldStyle}
                            onChange={(event) => handleRitiroTerminaleChange(event)}
                            placeholder={"Inserisci l'indirizzo per il ritiro"}
                            value={ritiroTerminale}
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12} md={3} className="mt-24">
                        <Typography variant="subtitle2">
                            Mail di contatto
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={9} className={classes.gridCenteredInputs}>
                        <TextField
                            className={classes.inputFieldStyle}
                            onChange={(event) => handleMailDiContattoChange(event)}
                            placeholder={"Inserisci la mail per il contatto"}
                            id="standard-required-email"
                            required
                            error={!emailRegex.test(String(mailDiContatto.toLowerCase())) && firstTimeEmail !== 0}
                            helperText={firstTimeEmail !== 0 && !emailRegex.test(String(mailDiContatto.toLowerCase())) ?
                                "Email non valida" : null}
                            value={mailDiContatto}
                            inputMode={"email"}
                        />
                    </Grid>
                </Grid>
                <Grid container className={"mb-24"}>
                    <Grid item xs={12} md={3} className="mt-24">
                        <Typography variant="subtitle2">
                            Numero telefonico di contatto
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={9} className={classes.gridCenteredInputs}>
                        <TextField
                            id="standard-required-telephone"
                            className={classes.inputFieldStyle}
                            onChange={(event) =>
                                handleNumeroTelefonicoDiContattoChange(event)}
                            placeholder={"Inserisci il numero di telefono"}
                            value={numeroTelefonicoDiContatto}
                            required
                            helperText={firstTimeTelephone !== 0 && numeroTelefonicoDiContatto.length === 0 ?
                                "Telefono non valido" : null}
                            error={numeroTelefonicoDiContatto.length === 0 && firstTimeTelephone !== 0}
                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E'
                                    || evt.key === '-' || evt.key === '.')
                                && evt.preventDefault()}
                            type={"number"}/>
                    </Grid>
                </Grid>
                <Button autoFocus
                        onClick={() => {
                            handleConttataciClick();
                        }}
                        disabled={disableButton()}
                        color="primary"
                        variant="outlined">
                    Contattaci
                </Button>
                <Button onClick={props.returnToMenu}
                        color="primary"
                        variant="text">
                    Indietro
                </Button>
            </WhiteHeaderCard>

            {openRichiestaInviata && !loadingReportProblem ? (
                <RichiestaInviataDialog
                    open={openRichiestaInviata}
                    handleDialogClose={handleRichiestaInviataButton}
                    titleText={!errorReportProblem ? "Richiesta inviata" : "Richiesta non inviata"}
                    bodyText={!errorReportProblem ?
                        "Gentile cliente, la tua richiesta è stato presa in carico…entro poche ore potrai consultare lo stato della pratica nell’area richieste assistenza" :
                        "Gentile cliente c’è stato un problema nell’apertura della richiesta. Riprova più tardi oppure contattaci con le modalità indicate nell’area Richieste e Assistenza del portale"
                    }
                    handleRichiestaCloseButton={errorReportProblem ? () => setOpenRichiestaInviata(false) :
                        handleRichiestaInviataButton}
                />
            ) : null}
        </React.Fragment>
    )
}

GuastoTerminaleDialog.propTypes = {
    returnToMenu: PropTypes.func,
    closeAssistenza: PropTypes.func,
    selectedDevices: PropTypes.array
}


export default GuastoTerminaleDialog;
